export const navBarService = (function () {
  "use strict";

  const navBarItems = [
    {
      id: "toolbar_AlertsBtn",
      title: "navbar.alerts",
      route: "/alerts",
      keys: { and: ["varilla.alerts"] }
    },
    {
      id: "toolbar_InventoryBtn",
      title: "navbar.inventory",
      route: "/inventory",
      keys: { and: ["varilla.inventory"] }
    },
    {
      id: "toolbar_reportsBtn",
      title: "navbar.reports",
      subMenu: [
        {
          title: "navbar.performanceSummary",
          icon: 'dashboard',
          route: "/performance-summary"
        },
        {
          title: "navbar.idlingSummary",
          icon: 'dashboard',
          route: "/idling-discharge-summary"
        },
        {
          title: "navbar.chargeSummary",
          icon: 'dashboard',
          route: "/charge-summary"
        },
        {
          title: "navbar.dischargeSummary",
          icon: 'dashboard',
          route: "/dischargeSummary"
        }
      ]
    }
  ];

  function getMenuByUser() {
    // navBarItems
    let permissions = getPermissions();
    let admin = JSON.parse(localStorage.getItem("admin"));
    const navBarItemsTemp =
      JSON.parse(localStorage.getItem("menu")) || navBarItems;
    let result = [];
    navBarItemsTemp.forEach(navBarItem => {
      if (admin || validatePermissions(permissions, navBarItem)) {
        if (navBarItem.subMenu) {
          const items = [];
          const mainMenu = Object.assign({}, navBarItem);
          navBarItem.subMenu.forEach(subMenuItem => {
            if (admin || validatePermissions(permissions, subMenuItem)) {
              items.push(subMenuItem);
            }
          });
          mainMenu.subMenu = items;
          result.push(mainMenu);
        } else {
          result.push(navBarItem);
        }
      }
    });
    return result;
  }

  function validatePermissions(permissions, item) {
    if (item.keys) {
      if (item.keys.and) {
        const conditions = item.keys.and;
        let result = true;
        conditions.forEach(condition => {
          if (!permissions.includes(condition)) {
            result = result && false;
          }
        });
        return result;
      } else if (item.keys.or) {
        const conditions = item.keys.or;
        let result = false;
        conditions.forEach(condition => {
          if (permissions.includes(condition)) {
            result = result || true;
          }
        });
        return result;
      }
      return false;
    }
    return true;
  }

  function getPermissions() {
    return localStorage.getItem("privileges")
      ? JSON.parse(localStorage.getItem("privileges"))
      : [];
  }

  return {
    getMenuByUser
  };
})();
